import React from 'react'
import ImageCards from 'features/image-cards'
import VideoGallery from 'pages/DLP/components/video-gallery'
import { Button } from 'layouts'
import Quotes from 'pages/www/components/quotes/Quotes'
import ContentType from 'models/types/ts/contentType'
import SectionType from 'models/types/ts/sectionType'
import Hero from '../hero'
import Hero2 from '../hero2'
import Featured from '../featured'
import Mural from '../mural'
import CardList from '../card-list'
import YTVideo from '../ytvideo'
import CTATemplate from '../cta-template'
import CTACard from '../cta-card'
import Rewards from '../rewards'
import Leaderboards from '../leaderboards'
import { ContentHighlightPanel } from '../content-highlight-panel'
import { DlpCountDown } from '../dlp-count-down'
import { VideoHero } from '../video-hero'
import MediaQuotes from '../media-quotes'

interface ThemeConfig {
    includeButtonEverywhere?: {
        path: string
        text: string
        showPlatform?: boolean
        color?: string
        background?: string
    }
    legacy?: boolean
    VideoHero?: {
        cardBackgroundColor?: string
    }
    VideoCarousel?: {
        color?: string
        playButtonColor?: string
    }
    ContentHighlightPanel?: {
        color?: string
    }
}

interface ComponentFactoryProps {
    data: SectionType
    themeConfig: ThemeConfig
}

const ComponentFactory = ({
    data,
    themeConfig,
}: ComponentFactoryProps): JSX.Element => {
    const includeButtonEverywhere = themeConfig?.includeButtonEverywhere

    const CTAButton = includeButtonEverywhere && (
        <Button
            path={includeButtonEverywhere.path}
            size="large"
            showPlatform={includeButtonEverywhere.showPlatform}
            custom={{
                color: includeButtonEverywhere.color,
                background: includeButtonEverywhere.background,
            }}
        >
            {includeButtonEverywhere.text}
        </Button>
    )

    const components = {
        VideoHero: (
            <VideoHero
                section={data}
                cardBackgroundColor={
                    themeConfig?.VideoHero?.cardBackgroundColor
                }
            />
        ),
        Hero: themeConfig.legacy ? (
            <Hero section={data} align="left" />
        ) : (
            <Hero2 section={data} />
        ),
        HeroCenter: <Hero section={data} align="center" />,
        HeroRight: <Hero section={data} align="right" />,
        Featured: (
            <Featured
                section={data}
                CTAButton={<div style={{ marginTop: '40px' }}>{CTAButton}</div>}
            />
        ),
        ImageList: <ImageCards section={data} />,
        Mural: <Mural section={data} />,
        CardList: <CardList section={data} />,
        YTVideo: <YTVideo section={data} />,
        CTA: <CTATemplate section={data} />,
        CTACard: <CTACard section={data} />,
        Rewards: <Rewards section={data} />,
        Leaderboards: <Leaderboards section={data} />,
        VideoCarousel: (
            <VideoGallery
                section={data}
                color={themeConfig?.VideoCarousel?.color}
                playButtonColor={themeConfig.VideoCarousel?.playButtonColor}
                CTAButton={<div style={{ marginTop: '20px' }}>{CTAButton}</div>}
            />
        ),
        ContentHighlightPanel: (
            <ContentHighlightPanel
                section={data}
                color={themeConfig.ContentHighlightPanel?.color}
            />
        ),
        CountDown: <DlpCountDown section={data} />,
        MediaQuotes: <MediaQuotes section={data} />,
    }

    if (!data) return null

    // console.log('🚀 ~ data:', data)

    const componentTemplate = components[data.template]
    if (data.template == null || componentTemplate == null) {
        return null
    }

    return React.cloneElement(componentTemplate, { section: data })
}

export default ComponentFactory
